var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIAbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.31 116.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f37021;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.25,0v103.86c0,7.1,5.75,12.86,12.86,12.86s12.86-5.76,12.86-12.86v-43.36l54.56,52.61c2.5,2.41,5.71,3.6,8.93,3.6s6.73-1.32,9.26-3.93c4.93-5.11,4.78-13.25-.33-18.18L43.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,103.77c0,7.1,5.76,12.86,12.86,12.86s12.86-5.75,12.86-12.86v-44.23L0,34.74v69.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAbig);
export default __webpack_public_path__ + "static/media/iAbig.4cb84c92b309a71caff47b08f8d64d22.svg";
export { ForwardRef as ReactComponent };